import React from 'react';
import Icon from './Icon';

/**
 * Reusable share actions bar.
 */
const ShareActions = ({ label = 'Condividi', className = '', style }) => {
  return (
    <div className={`share-actions ${className}`} style={style}>
      {label && <span className="share-actions__label hide-mobile">{label}</span>}
      <button className="share-actions__btn" aria-label="Facebook"><Icon name="Facebook" size={16} /></button>
      <button className="share-actions__btn" aria-label="Twitter"><Icon name="Twitter" size={16} /></button>
      <button className="share-actions__btn" aria-label="WhatsApp"><Icon name="MessageCircle" size={16} /></button>
      <button className="share-actions__btn" aria-label="Copia link"><Icon name="Link2" size={16} /></button>
    </div>
  );
};

export default ShareActions;
